/* eslint-disable react-hooks/rules-of-hooks */
'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   InputRightElement,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
} from '@chakra-ui/react';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
// import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { deleteReportFormat, getReportFormat, getReportStockDetail } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import { useBusinessType, useGlobal, useUser } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
// import { stockDrop, stockStatusDrop, stocktype } from 'constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { IoFilterOutline } from 'react-icons/io5';
import StockFilter from '../components/StockFilter';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { motion } from 'framer-motion';
import { MdCompress, MdDelete, MdExpand, MdOutlineRefresh } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { deleteRecord } from 'utils/util';
import SalesDetails from 'components/salesDetails/SalesDetails';
import ColumnShowHide from '../components/Columnshowhide';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import Loader from 'views/admin/default/Loader';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const Stock = () => {
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const iconColor = useColorModeValue('#000000', '#ffffff');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Context and Redux
   const { companyList } = useGlobal();
   const { businessTypes } = useBusinessType();
   const dispatch = useDispatch();
   const salesReport = useSelector((state) => state.reports?.stock || []);
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const dbName = localStorage.getItem('dbName');

   // Refs
   const abortControllerRef = useRef(null);
   const searchTimeoutRef = useRef(null);
   const wrapperRef = useRef();
   const isInitialMount = useRef(true);

   const viewData = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData;

      const pagination = viewData?.pagination;

      return { viewDetail: data, paginate: pagination };
   }, [viewData, viewData?.pagination]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);

   // State
   const [allExpanded, setAllExpanded] = useState(false);
   const [itemWiseSelected, setItemWiseSelected] = useState('Item + Serial-Wise');
   const [stockWiseSelected, setStockWiseSelected] = useState(null);
   const [stockTypeSelected, setStockTypeSelected] = useState({
      value: 1,
      label: 'STORE STOCK',
   });
   const [serialFilter, setSerialFilter] = useState({
      value: 0,
      label: 'All',
   });
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [editData, setEditData] = useState({});
   const [showHideData, setShowHideData] = useState({});
   const [sortOrder, setSortOrder] = useState('asc');
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [expanded, setExpanded] = useState(false);
   const [expandedItems, setExpandedItems] = useState({});
   const [searchQuery, setSearchQuery] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 7);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });

   // Disclosures
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { isOpen, onOpen, onClose } = useDisclosure();

   const stocktype = [
      { id: 1, name: 'STORE STOCK' },
      { id: 2, name: 'REPAIRING STOCK' },
   ];
   const serialType = [
      { id: 0, name: 'All' },
      { id: 1, name: 'Serialized' },
      { id: 2, name: 'Non-Serialized' },
   ];
   const stockDrop = useMemo(
      () => [
         { id: 0, name: 'Item + Serial-Wise', value: 'Item + Serial-Wise' },
         { id: 1, name: 'Item-wise', value: 'Item-wise' },
         { id: 2, name: 'Serial-Wise', value: 'Serial-Wise' },
      ],
      [],
   );

   const allowedDefNames = ['Item + Serial-Wise', 'Item-wise', 'Serial-Wise'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.id,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));

   const stockTypeOptions = [
      {
         // label: 'Standard Formats',
         options: stockDrop.map((item) => ({
            id: item.id,
            value: item.value,
            label: item.name,
            isStatic: true,
         })),
      },
      ...(dynamicOptions.length > 0
         ? [
            {
               label: 'Custom Formats',
               options: dynamicOptions,
            },
         ]
         : []),
   ];
   const selectedReportType = stockDrop.find(
      (option) => option.value === itemWiseSelected || option.value === itemWiseSelected?.value,
   );
   const staticOption = selectedReportType?.value;

   const stockStatusDrop = [
      { id: 0, name: 'All' },
      { id: 1, name: 'Completed' },
      { id: 2, name: 'Pending' },
   ];

   const dynamicValues = dynamicOptions.map((option) => option.value);

   const dynamicOptionValues = dynamicOptions.find((option) => option.value === itemWiseSelected?.value);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const { user } = useUser();
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;

   const useStockReportColumns = useCallback(() => {
      const getActualReportType = (selected) => {
         if (!selected) return 'Item + Serial-Wise'; // default

         // Handle dynamic format objects
         if (typeof selected === 'object') {
            if (selected.formatData) {
               return selected.formatData.defName;
            }
            if (selected.value && dynamicValues.includes(selected.value)) {
               const dynamicFormat = dynamicOptions.find((option) => option.value === selected.value);
               return dynamicFormat?.formatData?.defName || 'Item + Serial-Wise';
            }
         }

         // Handle static values
         if (typeof selected === 'string') {
            return selected;
         }

         // Handle numeric values
         if (typeof selected === 'number') {
            const staticOption = stockDrop.find((option) => option.id === selected);
            return staticOption?.value || 'Item + Serial-Wise';
         }

         return 'Item + Serial-Wise';
      };

      const reportType = getActualReportType(itemWiseSelected);
      const isPartyReport = reportType === 'Item + Serial-Wise';

      // Get viewJson for dynamic formats
      const viewJson =
         typeof itemWiseSelected === 'object' && itemWiseSelected.formatData
            ? itemWiseSelected.formatData.viewJson || []
            : [];

      // Rest of your existing useStockReportColumns logic...
      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem) {
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const getItemSerialWiseColumns = () => [
         ...(!isPartyReport
            ? [
               {
                  id: 'itemName',
                  header: getColumnInfo('Item Name').title,
                  accessor: 'itemName',
                  isShow: getColumnInfo('Item Name').isShow,
                  color: getColumnInfo('Item Name').color,
                  isBold: getColumnInfo('Item Name').isBold,
                  isItalic: getColumnInfo('Item Name').isItalic,
                  orderNo: getColumnInfo('Item Name').orderNo,
                  flex: getColumnInfo('Item Name').flex,
                  render: (value) => (
                     <Text
                        fontWeight={getColumnInfo('Item Name').isBold ? 'bold' : 'normal'}
                        fontStyle={getColumnInfo('Item Name').isItalic ? 'italic' : 'normal'}
                        color={getColumnInfo('Item Name').color}>
                        {value}
                     </Text>
                  ),
               },
            ]
            : []),
         {
            id: 'date',
            header: getColumnInfo('Date').title,
            accessor: 'transactionAt',
            isShow: getColumnInfo('Date').isShow,
            color: getColumnInfo('Date').color,
            isBold: getColumnInfo('Date').isBold,
            isItalic: getColumnInfo('Date').isItalic,
            orderNo: getColumnInfo('Date').orderNo,
            flex: getColumnInfo('Date').flex,
            render: (value) => formatDateToDDMMYYYY(value),
         },
         {
            id: 'docno',
            header: getColumnInfo('Doc#').title,
            accessor: 'docno',
            isShow: getColumnInfo('Doc#').isShow,
            color: getColumnInfo('Doc#').color,
            isBold: getColumnInfo('Doc#').isBold,
            isItalic: getColumnInfo('Doc#').isItalic,
            orderNo: getColumnInfo('Doc#').orderNo,
            flex: getColumnInfo('Doc#').flex,
         },
         {
            id: 'serialNo',
            header: getColumnInfo('Serial No').title,
            accessor: 'serialNo',
            isShow: getColumnInfo('Serial No').isShow,
            color: getColumnInfo('Serial No').color,
            isBold: getColumnInfo('Serial No').isBold,
            isItalic: getColumnInfo('Serial No').isItalic,
            orderNo: getColumnInfo('Serial No').orderNo,
            flex: getColumnInfo('Serial No').flex,
            render: (value) => value || '-',
         },
         {
            id: 'daybook',
            header: getColumnInfo('Daybook').title,
            accessor: 'daybook',
            isShow: getColumnInfo('Daybook').isShow,
            color: getColumnInfo('Daybook').color,
            isBold: getColumnInfo('Daybook').isBold,
            isItalic: getColumnInfo('Daybook').isItalic,
            orderNo: getColumnInfo('Daybook').orderNo,
            flex: getColumnInfo('Daybook').flex,
         },
         {
            id: 'account',
            header: getColumnInfo('Account').title,
            accessor: 'account',
            isShow: getColumnInfo('Account').isShow,
            color: getColumnInfo('Account').color,
            isBold: getColumnInfo('Account').isBold,
            isItalic: getColumnInfo('Account').isItalic,
            orderNo: getColumnInfo('Account').orderNo,
            flex: getColumnInfo('Account').flex,
         },
         {
            id: 'itemRate',
            header: getColumnInfo('Item Rate').title,
            accessor: 'itemRate',
            isNumeric: true,
            isShow: getColumnInfo('Item Rate').isShow,
            color: getColumnInfo('Item Rate').color,
            isBold: getColumnInfo('Item Rate').isBold,
            isItalic: getColumnInfo('Item Rate').isItalic,
            orderNo: getColumnInfo('Item Rate').orderNo,
            flex: getColumnInfo('Item Rate').flex,
            render: (value) => `₹${parseFloat(value || 0).toLocaleString()}`,
         },
         {
            id: 'noOfDays',
            header: getColumnInfo('No of Days').title,
            accessor: 'noOfDays',
            isNumeric: true,
            isShow: getColumnInfo('No of Days').isShow,
            color: getColumnInfo('No of Days').color,
            isBold: getColumnInfo('No of Days').isBold,
            isItalic: getColumnInfo('No of Days').isItalic,
            orderNo: getColumnInfo('No of Days').orderNo,
            flex: getColumnInfo('No of Days').flex,
            render: (value) => `${parseFloat(value || 0).toLocaleString()}`,
         },
         {
            id: 'pcs',
            header: getColumnInfo('Pcs').title,
            accessor: 'pcs',
            isNumeric: true,
            isShow: getColumnInfo('Pcs').isShow,
            color: getColumnInfo('Pcs').color,
            isBold: getColumnInfo('Pcs').isBold,
            isItalic: getColumnInfo('Pcs').isItalic,
            orderNo: getColumnInfo('Pcs').orderNo,
            flex: getColumnInfo('Pcs').flex,
         },
         {
            id: 'exprate',
            header: getColumnInfo('exprate').title,
            accessor: 'exprate',
            isNumeric: true,
            isShow: getColumnInfo('exprate').isShow,
            color: getColumnInfo('exprate').color,
            isBold: getColumnInfo('exprate').isBold,
            isItalic: getColumnInfo('exprate').isItalic,
            orderNo: getColumnInfo('exprate').orderNo,
            flex: getColumnInfo('exprate').flex,
            render: (value) => `₹${value.toLocaleString()}`,
         },
         {
            id: 'amount',
            header: getColumnInfo('Amount').title,
            accessor: 'TotalRate',
            isNumeric: true,
            isShow: getColumnInfo('Amount').isShow,
            color: getColumnInfo('Amount').color,
            isBold: getColumnInfo('Amount').isBold,
            isItalic: getColumnInfo('Amount').isItalic,
            orderNo: getColumnInfo('Amount').orderNo,
            flex: getColumnInfo('Amount').flex,
            render: (value) => `₹${value || 0}`,
         },
      ];

      const getSerialWiseColumns = () => [
         {
            id: 'itemName',
            header: getColumnInfo('Item Name').title,
            accessor: 'itemName',
            isShow: getColumnInfo('Item Name').isShow,
            color: getColumnInfo('Item Name').color,
            isBold: getColumnInfo('Item Name').isBold,
            isItalic: getColumnInfo('Item Name').isItalic,
            orderNo: getColumnInfo('Item Name').orderNo,
            flex: getColumnInfo('Item Name').flex,
            render: (value) => (
               <Text
                  fontWeight={getColumnInfo('Item Name').isBold ? 'bold' : 'normal'}
                  fontStyle={getColumnInfo('Item Name').isItalic ? 'italic' : 'normal'}
                  color={getColumnInfo('Item Name').color}>
                  {value}
               </Text>
            ),
         },
         {
            id: 'serialNo',
            header: getColumnInfo('Serial No').title,
            accessor: 'serialNo',
            isShow: getColumnInfo('Serial No').isShow,
            color: getColumnInfo('Serial No').color,
            isBold: getColumnInfo('Serial No').isBold,
            isItalic: getColumnInfo('Serial No').isItalic,
            orderNo: getColumnInfo('Serial No').orderNo,
            flex: getColumnInfo('Serial No').flex,
            render: (value) => value || '-',
         },
         {
            id: 'date',
            header: getColumnInfo('Date').title,
            accessor: 'transactionAt',
            isShow: getColumnInfo('Date').isShow,
            color: getColumnInfo('Date').color,
            isBold: getColumnInfo('Date').isBold,
            isItalic: getColumnInfo('Date').isItalic,
            orderNo: getColumnInfo('Date').orderNo,
            flex: getColumnInfo('Date').flex,
            render: (value) => formatDateToDDMMYYYY(value),
         },
         {
            id: 'docno',
            header: getColumnInfo('Doc#').title,
            accessor: 'docno',
            isShow: getColumnInfo('Doc#').isShow,
            color: getColumnInfo('Doc#').color,
            isBold: getColumnInfo('Doc#').isBold,
            isItalic: getColumnInfo('Doc#').isItalic,
            orderNo: getColumnInfo('Doc#').orderNo,
            flex: getColumnInfo('Doc#').flex,
         },
         {
            id: 'daybook',
            header: getColumnInfo('Daybook').title,
            accessor: 'daybook',
            isShow: getColumnInfo('Daybook').isShow,
            color: getColumnInfo('Daybook').color,
            isBold: getColumnInfo('Daybook').isBold,
            isItalic: getColumnInfo('Daybook').isItalic,
            orderNo: getColumnInfo('Daybook').orderNo,
            flex: getColumnInfo('Daybook').flex,
         },
         {
            id: 'account',
            header: getColumnInfo('Account').title,
            accessor: 'account',
            isShow: getColumnInfo('Account').isShow,
            color: getColumnInfo('Account').color,
            isBold: getColumnInfo('Account').isBold,
            isItalic: getColumnInfo('Account').isItalic,
            orderNo: getColumnInfo('Account').orderNo,
            flex: getColumnInfo('Account').flex,
         },
         {
            id: 'itemRate',
            header: getColumnInfo('Item Rate').title,
            accessor: 'itemRate',
            isNumeric: true,
            isShow: getColumnInfo('Item Rate').isShow,
            color: getColumnInfo('Item Rate').color,
            isBold: getColumnInfo('Item Rate').isBold,
            isItalic: getColumnInfo('Item Rate').isItalic,
            orderNo: getColumnInfo('Item Rate').orderNo,
            flex: getColumnInfo('Item Rate').flex,
            render: (value) => `₹${parseFloat(value || 0).toLocaleString()}`,
         },
         {
            id: 'noOfDays',
            header: getColumnInfo('No of Days').title,
            accessor: 'noOfDays',
            isNumeric: true,
            isShow: getColumnInfo('No of Days').isShow,
            color: getColumnInfo('No of Days').color,
            isBold: getColumnInfo('No of Days').isBold,
            isItalic: getColumnInfo('No of Days').isItalic,
            orderNo: getColumnInfo('No of Days').orderNo,
            flex: getColumnInfo('No of Days').flex,
            render: (value) => `${parseFloat(value || 0).toLocaleString()}`,
         },
         {
            id: 'pcs',
            header: getColumnInfo('Pcs').title,
            accessor: 'pcs',
            isNumeric: true,
            isShow: getColumnInfo('Pcs').isShow,
            color: getColumnInfo('Pcs').color,
            isBold: getColumnInfo('Pcs').isBold,
            isItalic: getColumnInfo('Pcs').isItalic,
            orderNo: getColumnInfo('Pcs').orderNo,
            flex: getColumnInfo('Pcs').flex,
         },
         {
            id: 'exprate',
            header: getColumnInfo('exprate').title,
            accessor: 'exprate',
            isNumeric: true,
            isShow: getColumnInfo('exprate').isShow,
            color: getColumnInfo('exprate').color,
            isBold: getColumnInfo('exprate').isBold,
            isItalic: getColumnInfo('exprate').isItalic,
            orderNo: getColumnInfo('exprate').orderNo,
            flex: getColumnInfo('exprate').flex,
            render: (value) => `₹${value.toLocaleString()}`,
         },
         {
            id: 'amount',
            header: getColumnInfo('Amount').title,
            accessor: 'TotalRate',
            isNumeric: true,
            isShow: getColumnInfo('Amount').isShow,
            color: getColumnInfo('Amount').color,
            isBold: getColumnInfo('Amount').isBold,
            isItalic: getColumnInfo('Amount').isItalic,
            orderNo: getColumnInfo('Amount').orderNo,
            flex: getColumnInfo('Amount').flex,
            render: (value) => `₹${value || 0}`,
         },
      ];

      const getItemWiseColumns = () => [
         {
            id: 'itemName',
            header: getColumnInfo('Item Name').title,
            accessor: 'itemName',
            isShow: getColumnInfo('Item Name').isShow,
            color: getColumnInfo('Item Name').color,
            isBold: getColumnInfo('Item Name').isBold,
            isItalic: getColumnInfo('Item Name').isItalic,
            orderNo: getColumnInfo('Item Name').orderNo,
            flex: getColumnInfo('Item Name').flex,
            render: (value) => (
               <Text
                  fontWeight={getColumnInfo('Item Name').isBold ? 'bold' : 'normal'}
                  fontStyle={getColumnInfo('Item Name').isItalic ? 'italic' : 'normal'}
                  color={getColumnInfo('Item Name').color}>
                  {value}
               </Text>
            ),
         },
         {
            id: 'OpeningBal1',
            header: getColumnInfo('Opening Bal').title,
            accessor: 'OpeningBal1',
            isShow: getColumnInfo('Opening Bal').isShow,
            color: getColumnInfo('Opening Bal').color,
            isBold: getColumnInfo('Opening Bal').isBold,
            isItalic: getColumnInfo('Opening Bal').isItalic,
            orderNo: getColumnInfo('Opening Bal').orderNo,
            flex: getColumnInfo('Opening Bal').flex,
         },
         {
            id: 'exprate',
            header: getColumnInfo('exprate').title,
            accessor: 'exprate',
            isNumeric: true,
            isShow: getColumnInfo('exprate').isShow,
            color: getColumnInfo('exprate').color,
            isBold: getColumnInfo('exprate').isBold,
            isItalic: getColumnInfo('exprate').isItalic,
            orderNo: getColumnInfo('exprate').orderNo,
            flex: getColumnInfo('exprate').flex,
            render: (value) => `₹${value || 0}`,
         },
         {
            id: 'PurchasePcs1',
            header: getColumnInfo('Purchase Pcs').title,
            accessor: 'PurchasePcs1',
            isNumeric: true,
            isShow: getColumnInfo('Purchase Pcs').isShow,
            color: getColumnInfo('Purchase Pcs').color,
            isBold: getColumnInfo('Purchase Pcs').isBold,
            isItalic: getColumnInfo('Purchase Pcs').isItalic,
            orderNo: getColumnInfo('Purchase Pcs').orderNo,
            flex: getColumnInfo('Purchase Pcs').flex,
         },
         {
            id: 'SalePcs1',
            header: getColumnInfo('Sale Pcs').title,
            accessor: 'SalePcs1',
            isNumeric: true,
            isShow: getColumnInfo('Sale Pcs').isShow,
            color: getColumnInfo('Sale Pcs').color,
            isBold: getColumnInfo('Sale Pcs').isBold,
            isItalic: getColumnInfo('Sale Pcs').isItalic,
            orderNo: getColumnInfo('Sale Pcs').orderNo,
            flex: getColumnInfo('Sale Pcs').flex,
         },
         {
            id: 'Bal1',
            header: getColumnInfo('Balance').title,
            accessor: 'Bal1',
            isNumeric: true,
            isShow: getColumnInfo('Balance').isShow,
            color: getColumnInfo('Balance').color,
            isBold: getColumnInfo('Balance').isBold,
            isItalic: getColumnInfo('Balance').isItalic,
            orderNo: getColumnInfo('Balance').orderNo,
            flex: getColumnInfo('Balance').flex,
         },
      ];
      return {
         getItemSerialWiseColumns,
         getItemWiseColumns,
         getSerialWiseColumns,
         reportType,
      };
   });

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ff4d4f',
                  padding: '0 5px',
               }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const handleDeleteFormat = async (id) => {
      try {
         // Call the action creator
         await dispatch(deleteReportFormat(id));

         // Reset edit state if this was the currently edited format
         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         // Errors are already handled in the action creator
         console.error('Delete error:', error);
      }
   };

   const stockReportColumns = useStockReportColumns();

   const dynamicColumns = useMemo(() => {
      switch (stockReportColumns.reportType.label) {
         case 'Item + Serial-Wise':
            return stockReportColumns.getItemSerialWiseColumns();
         case 'Item-wise':
            return stockReportColumns.getItemWiseColumns();
         case 'Serial-Wise':
            return stockReportColumns.getSerialWiseColumns();
         default:
            return stockReportColumns.getItemSerialWiseColumns();
      }
   }, [stockReportColumns]);

   const columnsData = useMemo(() => {
      return dynamicColumns
         .filter((col) => col.isShow !== false)
         .map((col, index) => ({
            key: col?.id,
            label: col?.header,
            title: col?.header,
            width: col?.width,
            index: index + 1,
            status: true,
         }));
   }, [dynamicColumns]);

   // Initialize expanded state for all items when data loads
   useEffect(() => {
      if (salesReport.length > 0) {
         const newExpanded = {};
         salesReport.forEach((companyData) => {
            const companyKey = `company-${companyData.companyId}`;
            newExpanded[companyKey] = true;

            companyData.data?.forEach((itemData) => {
               const itemKey = `item-${itemData.itemId}-${companyData.companyId}`;
               newExpanded[itemKey] = true;
            });
         });
         setExpandedItems(newExpanded);
      }
   }, [salesReport]);

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   // Initialize default values
   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }

      if (businessTypes?.businessType === 'MOBILE') {
         setItemWiseSelected({ value: stockDrop[0].id, label: stockDrop[0].name });
         setStockWiseSelected({ value: stockStatusDrop[2].id, label: stockStatusDrop[2].name });
      }
   }, [companyList, businessTypes]);

   // Data fetching with optimized search - FIXED: Added all dependencies
   const fetchData = useCallback(async () => {
      // Validate companyIds - must be an array with at least one valid number
      if (
         !Array.isArray(companyIds) ||
         companyIds.length === 0 ||
         companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
      ) {
         console.log('Invalid company IDs, skipping API call');
         return;
      }

      // Cancel any pending request
      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      setIsLoading(true);

      try {
         // Additional validation for all required parameters
         if (dateRange.fromDate && dateRange.toDate) {
            // Filter out any invalid IDs just to be safe
            const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

            const params = {
               companyIds: validCompanyIds.join(','),
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               stockStatus: stockWiseSelected?.value,
               type: stockTypeSelected?.value,
               serialFilter: serialFilter?.value,
               search: searchQuery.trim(),
            };
            await dispatch(getReportStockDetail(params), { signal: abortControllerRef.current.signal });
         }
      } catch (error) {
         if (error.name !== 'AbortError') {
            console.error('Error fetching stock details:', error);
         }
      } finally {
         setIsLoading(false);
         abortControllerRef.current = null;
      }
   }, [
      dispatch,
      companyIds,
      stockWiseSelected?.value,
      stockTypeSelected?.value,
      serialFilter?.value,
      searchQuery,
      dateRange.fromDate,
      dateRange.toDate,
   ]);

   // FIXED: Single useEffect for data fetching with proper dependencies
   useEffect(() => {
      // Skip initial mount to prevent duplicate calls
      if (isInitialMount.current) {
         isInitialMount.current = false;
         return;
      }

      // Validate all parameters before fetching data
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidDateRange) {
         const timer = setTimeout(() => {
            fetchData();
         }, 300); // Debounce delay

         return () => {
            clearTimeout(timer);
            if (abortControllerRef.current) {
               abortControllerRef.current.abort();
            }
         };
      }
   }, [
      companyIds,
      dateRange.fromDate,
      dateRange.toDate,
      stockWiseSelected?.value,
      stockTypeSelected?.value,
      searchQuery,
      fetchData, // Include fetchData in dependencies
   ]);

   // Search handler with debounce
   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
   }, []);

   const handleSortChange = (order) => {
      console.log('Sort Order Changed:', order);
      setSortOrder(order);
      // Optionally, you can trigger data refresh here
   };

   // Handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   const expandAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         companyData.data?.forEach((itemData) => {
            const itemKey = `item-${itemData.itemId}-${companyData.companyId}`;
            newExpanded[itemKey] = true;
         });
      });
      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [salesReport]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true; // Keep companies expanded

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = false; // Collapse all items
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [salesReport]);
   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   const handleItemWiseChange = useCallback((option) => {
      setItemWiseSelected(option);
   }, []);

   const handleStockWiseChange = useCallback((option) => {
      setStockWiseSelected(option);
   }, []);

   // Formatting functions
   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   }, []);

   const exportToExcel = useCallback(() => {
      if (!salesReport || !Array.isArray(salesReport)) {
         console.error('No data to export or data is not in expected format');
         return;
      }

      try {
         const workbook = XLSX.utils.book_new();

         // Move hook calls to component level and pass them as dependencies
         const { getItemSerialWiseColumns, getItemWiseColumns, getSerialWiseColumns } = stockReportColumns;

         // Define colors matching your UI
         const colors = {
            companyHeader: 'F8FAFC',
            itemHeader: 'F8FAFC',
            oddRow: 'FFFFFF',
            evenRow: 'EFF6FF',
            totalRow: 'E6FFED',
            headerText: '000000',
            subHeaderBg: 'C7C8CC',
         };

         // Define all format types to export
         const formatTypes = [
            { value: 0, name: 'Item+Serial-wise', getColumns: getItemSerialWiseColumns },
            { value: 1, name: 'Item-wise', getColumns: getItemWiseColumns },
            { value: 2, name: 'Serial-wise', getColumns: getSerialWiseColumns },
         ];

         // Helper functions
         const convertColorToHex = (color) => {
            if (!color) return '000000';
            if (color.startsWith('#')) return color.substring(1);
            if (color.startsWith('rgb')) {
               const matches = color.match(/\d+/g);
               if (matches && matches.length >= 3) {
                  return matches
                     .slice(0, 3)
                     .map((x) => parseInt(x).toString(16).padStart(2, '0'))
                     .join('');
               }
            }
            return '000000';
         };

         const getExcelColumnStyle = (column, isHeader = false) => {
            const baseStyle = {
               font: {
                  color: { rgb: convertColorToHex(column.color || textColor) },
                  bold: isHeader ? true : column.isBold || false,
               },
               alignment: {
                  horizontal: column.isNumeric ? 'right' : 'left',
               },
            };

            if (column.isItalic) {
               baseStyle.font.italic = true;
            }

            if (isHeader) {
               baseStyle.fill = { fgColor: { rgb: colors.subHeaderBg } };
               baseStyle.font.bold = true;
            }

            return baseStyle;
         };

         const getOrderedColumns = (columns) => {
            return [...columns].sort((a, b) => {
               const orderA = a.orderNo || 0;
               const orderB = b.orderNo || 0;
               return orderA - orderB;
            });
         };

         const renderCellValueForExcel = (column, rowData, itemData = null) => {
            let value;

            if (typeof column.accessor === 'function') {
               value = column.accessor(rowData);
            } else if (column.accessor === 'itemName' && itemData) {
               value = itemData.itemName;
            } else {
               value = rowData[column.accessor];
            }

            if (column.id === 'date' && value) {
               return formatDateToDDMMYYYY(value);
            }

            if (column.id === 'noOfDays') {
               // Format number of days as integer
               const numValue = parseInt(value) || 0;
               return numValue;
            }

            if (column.isNumeric && typeof value !== 'undefined' && value !== null) {
               const numValue = parseFloat(value);
               return isNaN(numValue) ? 0 : numValue;
            }

            return value || '';
         };

         // Process each format type
         formatTypes.forEach((formatType) => {
            const allColumns = formatType.getColumns().filter((col) => col.isShow === true);
            const orderedColumns = getOrderedColumns(allColumns);

            if (orderedColumns.length === 0) {
               console.warn(`No visible columns found for format ${formatType.name}`);
               return;
            }

            // Process each company for this format
            salesReport.forEach((companyData) => {
               if (!companyData) return;

               const companyName = companyData.companyName || 'Unknown Company';
               const worksheetName = `${companyName}_${formatType.name}`.substring(0, 31);
               const worksheetData = [];
               const merges = [];
               const styles = [];
               let rowIndex = 0;

               // Calculate company totals based on format type
               let companyTotalOpening = 0;
               let companyTotalPurchase = 0;
               let companyTotalSale = 0;
               let companyTotalBalance = 0;
               let companyTotalPcs = 0;
               let companyTotalAmount = 0;
               let companyTotalExprate = 0;

               if (formatType.value === 0) {
                  // Item+Serial-wise totals
                  companyTotalPcs = companyData.data.reduce(
                     (sum, item) => sum + item.data.reduce((itemSum, serial) => itemSum + parseInt(serial.pcs || 0), 0),
                     0,
                  );
                  companyTotalAmount = companyData.data.reduce(
                     (sum, item) =>
                        sum +
                        item.data.reduce(
                           (itemSum, serial) =>
                              itemSum + parseFloat(serial.TotalRate || 0) * parseFloat(serial.pcs || 0),
                           0,
                        ),
                     0,
                  );
                  companyTotalExprate = companyData.data.reduce(
                     (sum, item) =>
                        sum +
                        item.data.reduce(
                           (itemSum, serial) => itemSum + parseFloat(serial.exprate || 0) * parseFloat(serial.pcs || 0),
                           0,
                        ),
                     0,
                  );
               } else if (formatType.value === 1) {
                  // Item-wise totals
                  companyTotalOpening = companyData.data.reduce(
                     (sum, item) => sum + parseInt(item.OpeningBal1 || 0),
                     0,
                  );
                  companyTotalPurchase = companyData.data.reduce(
                     (sum, item) => sum + parseInt(item.PurchasePcs1 || 0),
                     0,
                  );
                  companyTotalSale = companyData.data.reduce((sum, item) => sum + parseInt(item.SalePcs1 || 0), 0);
                  companyTotalBalance = companyData.data.reduce((sum, item) => sum + parseInt(item.Bal1 || 0), 0);
               } else if (formatType.value === 2) {
                  // Serial-wise totals
                  companyTotalPcs = companyData.data
                     .flatMap((item) => item.data.map((serial) => parseInt(serial.pcs || 0)))
                     .reduce((sum, pcs) => sum + pcs, 0);
                  companyTotalAmount = companyData.data
                     .flatMap((item) =>
                        item.data.map((serial) => parseFloat(serial.TotalRate || 0) * parseFloat(serial.pcs || 0)),
                     )
                     .reduce((sum, amount) => sum + amount, 0);
                  companyTotalExprate = companyData.data
                     .flatMap((item) =>
                        item.data.map((serial) => parseFloat(serial.exprate || 0) * parseFloat(serial.pcs || 0)),
                     )
                     .reduce((sum, amount) => sum + amount, 0);
               }

               // Create company header row based on format type
               if (formatType.value === 0) {
                  // Item+Serial-wise format header
                  const headerData = [companyName];
                  const headerStyles = [
                     {
                        font: { bold: true, color: { rgb: colors.headerText }, size: 14 },
                        fill: { fgColor: { rgb: colors.companyHeader } },
                        alignment: { horizontal: 'left' },
                     },
                  ];

                  for (let i = 1; i < orderedColumns.length - 2; i++) {
                     headerData.push('');
                     headerStyles.push({ fill: { fgColor: { rgb: colors.companyHeader } } });
                  }

                  headerData.push(`Total Pcs: ${companyTotalPcs}`);
                  // UPDATED: Add No of Days to header
                  headerData.push(
                     `Total Exp: ₹${companyTotalExprate.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                     })}, Amt: ₹${companyTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                  );

                  headerStyles.push({
                     font: { bold: true, color: { rgb: colors.headerText } },
                     fill: { fgColor: { rgb: colors.companyHeader } },
                     alignment: { horizontal: 'right' },
                  });
                  headerStyles.push({
                     font: { bold: true, color: { rgb: colors.headerText } },
                     fill: { fgColor: { rgb: colors.companyHeader } },
                     alignment: { horizontal: 'right' },
                  });

                  worksheetData.push(headerData);
                  styles.push(headerStyles);
                  merges.push({
                     s: { r: rowIndex, c: 0 },
                     e: { r: rowIndex, c: Math.max(0, orderedColumns.length - 3) },
                  });
               } else if (formatType.value === 1) {
                  // Item-wise format header
                  const headerData = [companyName, ''];
                  const headerStyles = [
                     {
                        font: { bold: true, color: { rgb: colors.headerText }, size: 14 },
                        fill: { fgColor: { rgb: colors.companyHeader } },
                        alignment: { horizontal: 'left' },
                     },
                     { fill: { fgColor: { rgb: colors.companyHeader } } },
                  ];

                  const remainingCols = Math.max(0, orderedColumns.length - 2);
                  for (let i = 0; i < remainingCols; i++) {
                     if (i === 0) headerData.push(`Opening: ${companyTotalOpening}`);
                     else if (i === 1) headerData.push(`Purchase: ${companyTotalPurchase}`);
                     else if (i === 2) headerData.push(`Sale: ${companyTotalSale}`);
                     else if (i === 3) headerData.push(`Balance: ${companyTotalBalance}`);
                     else headerData.push('');

                     headerStyles.push({
                        font: { bold: true, color: { rgb: colors.headerText } },
                        fill: { fgColor: { rgb: colors.companyHeader } },
                        alignment: { horizontal: 'right' },
                     });
                  }

                  worksheetData.push(headerData);
                  styles.push(headerStyles);
                  merges.push({ s: { r: rowIndex, c: 0 }, e: { r: rowIndex, c: 1 } });
               } else {
                  // Serial-wise format header
                  const headerData = [companyName];
                  const headerStyles = [
                     {
                        font: { bold: true, color: { rgb: colors.headerText }, size: 14 },
                        fill: { fgColor: { rgb: colors.companyHeader } },
                        alignment: { horizontal: 'left' },
                     },
                  ];

                  for (let i = 1; i < orderedColumns.length - 2; i++) {
                     headerData.push('');
                     headerStyles.push({ fill: { fgColor: { rgb: colors.companyHeader } } });
                  }

                  headerData.push(`Total Pcs: ${companyTotalPcs}`);
                  // UPDATED: Add No of Days to header
                  headerData.push(
                     `Total Exp: ₹${companyTotalExprate.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                     })}, Amt: ₹${companyTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                  );

                  headerStyles.push({
                     font: { bold: true, color: { rgb: colors.headerText } },
                     fill: { fgColor: { rgb: colors.companyHeader } },
                     alignment: { horizontal: 'right' },
                  });
                  headerStyles.push({
                     font: { bold: true, color: { rgb: colors.headerText } },
                     fill: { fgColor: { rgb: colors.companyHeader } },
                     alignment: { horizontal: 'right' },
                  });

                  worksheetData.push(headerData);
                  styles.push(headerStyles);
                  merges.push({
                     s: { r: rowIndex, c: 0 },
                     e: { r: rowIndex, c: Math.max(0, orderedColumns.length - 3) },
                  });
               }
               rowIndex++;

               // Empty row
               worksheetData.push([]);
               styles.push([]);
               rowIndex++;

               // Add data based on format type
               if (formatType.value === 0) {
                  // ITEM + SERIAL-WISE FORMAT
                  (companyData.data || []).forEach((itemData, itemIndex) => {
                     const itemTotalPcs = itemData.data.reduce((sum, serial) => sum + parseInt(serial.pcs || 0), 0);
                     const itemTotalExprate = itemData.data.reduce(
                        (sum, serial) => sum + parseFloat(serial.exprate || 0) * parseFloat(serial.pcs || 0),
                        0,
                     );
                     const itemTotalAmount = itemData.data.reduce(
                        (sum, serial) => sum + parseFloat(serial.TotalRate || 0) * parseFloat(serial.pcs || 0),
                        0,
                     );
                     const itemTotalNoOfDays = itemData.data.reduce(
                        (sum, serial) => sum + parseInt(serial.noOfDays || 0),
                        0,
                     );

                     const itemHeaderData = [itemData.itemName];
                     const itemHeaderStyles = [
                        {
                           font: { bold: true, color: { rgb: colors.headerText } },
                           fill: { fgColor: { rgb: colors.itemHeader } },
                           alignment: { horizontal: 'left' },
                        },
                     ];

                     for (let i = 1; i < orderedColumns.length - 2; i++) {
                        itemHeaderData.push('');
                        itemHeaderStyles.push({ fill: { fgColor: { rgb: colors.itemHeader } } });
                     }

                     itemHeaderData.push(`Pcs: ${itemTotalPcs}`);
                     // UPDATED: Add No of Days to item header
                     itemHeaderData.push(
                        `Days: ${itemTotalNoOfDays}, Exp: ₹${itemTotalExprate.toLocaleString('en-IN', {
                           minimumFractionDigits: 2,
                        })}, Amt: ₹${itemTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
                     );

                     itemHeaderStyles.push({
                        font: { bold: true, color: { rgb: colors.headerText } },
                        fill: { fgColor: { rgb: colors.itemHeader } },
                        alignment: { horizontal: 'right' },
                     });
                     itemHeaderStyles.push({
                        font: { bold: true, color: { rgb: colors.headerText } },
                        fill: { fgColor: { rgb: colors.itemHeader } },
                        alignment: { horizontal: 'right' },
                     });

                     worksheetData.push(itemHeaderData);
                     styles.push(itemHeaderStyles);
                     merges.push({
                        s: { r: rowIndex, c: 0 },
                        e: { r: rowIndex, c: Math.max(0, orderedColumns.length - 3) },
                     });
                     rowIndex++;

                     const detailedColumns = orderedColumns.filter((col) => col.accessor !== 'itemName');
                     const headerRow = detailedColumns.map((col) => col.header);
                     const headerStyles = detailedColumns.map((col) => getExcelColumnStyle(col, true));

                     worksheetData.push(headerRow);
                     styles.push(headerStyles);
                     rowIndex++;

                     (itemData.data || []).forEach((serialData, serialIndex) => {
                        const isEvenRow = serialIndex % 2 === 0;
                        const rowData = [];
                        const rowStyles = [];

                        detailedColumns.forEach((column) => {
                           const value = renderCellValueForExcel(column, serialData, itemData);
                           rowData.push(value);

                           const cellStyle = {
                              ...getExcelColumnStyle(column),
                              fill: { fgColor: { rgb: isEvenRow ? colors.oddRow : colors.evenRow } },
                           };

                           if (column.isNumeric && typeof value === 'number') {
                              if (column.id === 'itemRate' || column.id === 'exprate' || column.id === 'amount') {
                                 cellStyle.numFmt = '"₹"#,##0.00';
                              } else if (column.id === 'noOfDays') {
                                 // Special formatting for No of Days
                                 cellStyle.numFmt = '#,##0';
                              } else {
                                 cellStyle.numFmt = '#,##0';
                              }
                           }

                           rowStyles.push(cellStyle);
                        });

                        worksheetData.push(rowData);
                        styles.push(rowStyles);
                        rowIndex++;
                     });

                     worksheetData.push([]);
                     styles.push([]);
                     rowIndex++;
                  });
               } else if (formatType.value === 1) {
                  // ITEM-WISE FORMAT
                  const headerRow = orderedColumns.map((col) => col.header);
                  const headerStyles = orderedColumns.map((col) => getExcelColumnStyle(col, true));

                  worksheetData.push(headerRow);
                  styles.push(headerStyles);
                  rowIndex++;

                  (companyData.data || []).forEach((itemData, index) => {
                     const isEvenRow = index % 2 === 0;
                     const rowData = [];
                     const rowStyles = [];

                     orderedColumns.forEach((column) => {
                        const value = renderCellValueForExcel(column, itemData);
                        rowData.push(value);

                        const cellStyle = {
                           ...getExcelColumnStyle(column),
                           fill: { fgColor: { rgb: isEvenRow ? colors.oddRow : colors.evenRow } },
                        };

                        if (column.isNumeric && typeof value === 'number') {
                           if (column.id === 'exprate') {
                              cellStyle.numFmt = '"₹"#,##0.00';
                           } else {
                              cellStyle.numFmt = '#,##0';
                           }
                        }

                        rowStyles.push(cellStyle);
                     });

                     worksheetData.push(rowData);
                     styles.push(rowStyles);
                     rowIndex++;
                  });
               } else if (formatType.value === 2) {
                  // SERIAL-WISE FORMAT
                  const headerRow = orderedColumns.map((col) => col.header);
                  const headerStyles = orderedColumns.map((col) => getExcelColumnStyle(col, true));

                  worksheetData.push(headerRow);
                  styles.push(headerStyles);
                  rowIndex++;

                  const serialData = companyData.data.flatMap((itemData) =>
                     itemData.data.map((serial) => ({ ...serial, itemName: itemData.itemName })),
                  );

                  serialData.forEach((serial, index) => {
                     const isEvenRow = index % 2 === 0;
                     const rowData = [];
                     const rowStyles = [];

                     orderedColumns.forEach((column) => {
                        const value = renderCellValueForExcel(column, serial);
                        rowData.push(value);

                        const cellStyle = {
                           ...getExcelColumnStyle(column),
                           fill: { fgColor: { rgb: isEvenRow ? colors.oddRow : colors.evenRow } },
                        };

                        if (column.isNumeric && typeof value === 'number') {
                           if (column.id === 'itemRate' || column.id === 'exprate' || column.id === 'amount') {
                              cellStyle.numFmt = '"₹"#,##0.00';
                           } else if (column.id === 'noOfDays') {
                              // Special formatting for No of Days
                              cellStyle.numFmt = '#,##0';
                           } else {
                              cellStyle.numFmt = '#,##0';
                           }
                        }

                        rowStyles.push(cellStyle);
                     });

                     worksheetData.push(rowData);
                     styles.push(rowStyles);
                     rowIndex++;
                  });
               }

               // Create worksheet with data
               const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

               // Apply styles to each cell
               styles.forEach((rowStyles, rowNum) => {
                  rowStyles.forEach((style, colNum) => {
                     if (style) {
                        const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                        if (!worksheet[cellAddress]) worksheet[cellAddress] = {};
                        worksheet[cellAddress].s = style;
                     }
                  });
               });

               // Apply merges
               worksheet['!merges'] = merges;

               // Set dynamic column widths
               const columnWidths = orderedColumns.map((column) => {
                  let baseWidth = 15;

                  if (column.id === 'itemName') baseWidth = 25;
                  else if (column.id === 'account') baseWidth = 20;
                  else if (column.id === 'daybook') baseWidth = 18;
                  else if (column.id === 'serialNo') baseWidth = 15;
                  else if (column.id === 'noOfDays') baseWidth = 12; // Width for No of Days
                  else if (column.isNumeric) baseWidth = 12;

                  const flexMultiplier = column.flex || 1;
                  const finalWidth = Math.max(baseWidth, (baseWidth * flexMultiplier) / 2);

                  return { wch: Math.min(finalWidth, 50) };
               });

               worksheet['!cols'] = columnWidths;

               XLSX.utils.book_append_sheet(workbook, worksheet, worksheetName);
            });
         });

         // Generate and download the file
         XLSX.writeFile(workbook, `Stock_Report_All_Formats_${new Date().toISOString().split('T')[0]}.xlsx`);
      } catch (error) {
         console.error('Error exporting to Excel:', error);
      }
   }, [salesReport, formatDateToDDMMYYYY, textColor, stockReportColumns]);

   // Then create your export function
   const exportToPDF = () => {
      if (!salesReport || !Array.isArray(salesReport)) {
         console.error('No data to export');
         return;
      }

      // SIMPLE FORMATTERS
      const formatDate = (dateString) => {
         if (!dateString) return '';
         const date = new Date(dateString);
         if (isNaN(date.getTime())) return '';
         return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getFullYear()}`;
      };

      const formatCurrency = (value) => {
         if (value === null || value === undefined || value === '') return '0.00';
         const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);
         return isNaN(num) ? '0.00' : num.toFixed(2);
      };

      const formatNumber = (value) => {
         if (value === null || value === undefined || value === '') return '0';
         const num = typeof value === 'string' ? parseInt(value.replace(/,/g, '')) : Number(value);
         return isNaN(num) ? '0' : num.toString();
      };

      const formatNoOfDays = (value) => {
         if (value === null || value === undefined || value === '') return '0';
         const num = typeof value === 'string' ? parseInt(value.replace(/,/g, '')) : Number(value);
         return isNaN(num) ? '0' : num.toString();
      };

      // CREATE PDF - SMALLER FONT SIZES
      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
      });

      const margin = 8;
      const pageWidth = doc.internal.pageSize.width - margin * 2;
      const pageHeight = doc.internal.pageSize.height;
      let currentY = margin;

      // TRACKING VARIABLES
      let isFirstPage = true;
      let currentCompanyData = null;

      // HEADER - ONLY ON FIRST PAGE
      const drawHeader = () => {
         if (!isFirstPage) return;

         // Main title
         doc.setFontSize(14);
         doc.setFont('helvetica', 'bold');
         doc.text(
            `Stock Report (${formatDate(dateRange.fromDate)} to ${formatDate(dateRange.toDate)})`,
            margin,
            currentY,
         );
         currentY += 5; // Reduced from 6

         // Company filter
         if (companyFilter && companyFilter.length > 0) {
            const companyNames = companyFilter
               .map((id) => companyList.find((c) => c.id === id)?.name || '')
               .filter((name) => name)
               .join(', ');

            if (companyNames) {
               doc.setFontSize(10);
               doc.setFont('helvetica', 'bold');
               doc.text(`Companies: ${companyNames}`, margin, currentY);
               currentY += 4; // Reduced from 5
            }
         }

         // Report type
         const reportType = itemWiseSelected?.label || 'Item + Serial-Wise';
         doc.setFontSize(10);
         doc.text(`Report Type: ${reportType}`, margin, currentY);
         currentY += 6; // Reduced from 8

         isFirstPage = false;
      };

      // COMPANY HEADER - ONLY ONCE PER COMPANY
      const drawCompanyHeader = (companyData) => {
         if (currentCompanyData?.companyName === companyData.companyName) return;

         currentCompanyData = companyData;

         // Calculate company totals
         let transactionCount = 0;
         let totalQty = 0;
         let totalAmount = 0;
         let totalNoOfDays = 0; // NEW: Add No of Days total

         companyData.data?.forEach((item) => {
            if (item.data && Array.isArray(item.data)) {
               item.data.forEach((serial) => {
                  transactionCount++;
                  totalQty += parseInt(serial.pcs || 0);
                  totalAmount += parseFloat(serial.TotalRate || serial.amount || 0);
                  totalNoOfDays += parseInt(serial.noOfDays || 0); // NEW: Add No of Days
               });
            }
         });

         // Check space for company header
         if (currentY + 8 > pageHeight - 15) {
            addNewPage(false);
         }

         // Company header - LESS SPACING
         doc.setFillColor(52, 152, 219);
         doc.rect(margin, currentY, pageWidth, 7, 'F'); // Reduced height

         doc.setFontSize(10); // Reduced from 11
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(255, 255, 255);

         // UPDATED: Include No of Days in header
         const companyText = `${companyData.companyName} (${formatNumber(
            transactionCount,
         )} transactions) Days: ${formatNoOfDays(totalNoOfDays)} Qty: ${formatNumber(totalQty)} Amt: ${formatCurrency(
            totalAmount,
         )}`;
         doc.text(companyText, margin + 2, currentY + 4.5); // Better vertical centering

         currentY += 8; // Reduced from 10
      };

      // ADD NEW PAGE
      const addNewPage = (showCompanyHeader = false) => {
         doc.addPage('landscape');
         currentY = margin;
      };

      // TABLE HEADERS - WITH RIGHT ALIGNMENT FOR NUMERIC COLUMNS
      const drawTableHeaders = () => {
         // Check space for headers
         if (currentY + 8 > pageHeight - 15) {
            addNewPage();
            return;
         }

         // Header background
         doc.setFillColor(248, 249, 250);
         doc.rect(margin, currentY, pageWidth, 5, 'F'); // Reduced height

         // Header text - SMALLER FONT
         doc.setFontSize(7);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(0, 0, 0);

         // UPDATED: Add No of Days column to positions - ADJUST WIDTHS
         const columns = [
            { text: 'Date', x: margin + 2, width: 22, align: 'left' },
            { text: 'Doc', x: margin + 26, width: 18, align: 'left' },
            { text: 'Daybook', x: margin + 46, width: 35, align: 'left' },
            { text: 'Account', x: margin + 83, width: 40, align: 'left' },
            { text: 'Serial No', x: margin + 125, width: 32, align: 'left' },
            { text: 'No of Days', x: margin + 159, width: 15, align: 'right' }, // NEW: No of Days column - RIGHT ALIGNED
            { text: 'Item Rate', x: margin + 176, width: 22, align: 'right' }, // RIGHT ALIGNED
            { text: 'Pcs', x: margin + 200, width: 12, align: 'right' }, // RIGHT ALIGNED
            { text: 'exprate', x: margin + 214, width: 22, align: 'right' }, // RIGHT ALIGNED
            { text: 'Amount', x: margin + 238, width: 25, align: 'right' }, // RIGHT ALIGNED
         ];

         columns.forEach((col) => {
            if (col.align === 'right') {
               // Calculate position for right-aligned text
               const textWidth = doc.getTextWidth(col.text);
               const rightX = col.x + col.width - 2; // 2mm padding from right
               doc.text(col.text, rightX - textWidth, currentY + 3.5);
            } else {
               doc.text(col.text, col.x, currentY + 3.5);
            }
         });

         currentY += 5; // Reduced from 6
      };

      // ITEM HEADER - TIGHTER SPACING
      const drawItemHeader = (itemName, itemData) => {
         // Check space
         if (currentY + 10 > pageHeight - 15) {
            addNewPage();
            return;
         }

         // Item header background
         doc.setFillColor(240, 248, 255);
         doc.rect(margin, currentY, pageWidth, 5, 'F'); // Reduced height

         // Item name with totals - SMALLER
         doc.setFontSize(9); // Reduced from 10
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(0, 51, 102);

         // Truncate if too long
         const maxWidth = pageWidth - 10;
         let displayName = itemName;
         if (doc.getTextWidth(itemName) > maxWidth) {
            for (let i = itemName.length; i > 0; i--) {
               const truncated = itemName.substring(0, i) + '...';
               if (doc.getTextWidth(truncated) <= maxWidth) {
                  displayName = truncated;
                  break;
               }
            }
         }

         doc.text(displayName, margin + 2, currentY + 3.5);

         currentY += 5; // Reduced from 6

         // ADD SEPARATOR LINE IMMEDIATELY AFTER ITEM HEADER
         doc.setDrawColor(220, 220, 220);
         doc.line(margin, currentY, margin + pageWidth, currentY);
         currentY += 2; // Small spacing after line
      };

      // DRAW SERIAL ROW - COMPACT VERSION
      const drawSerialRow = (serial, rowIndex) => {
         // Check space for row
         if (currentY + 6 > pageHeight - 15) {
            addNewPage();
            drawTableHeaders();
            rowIndex = 0;
         }

         // Row background - ALTERNATING COLORS
         if (rowIndex % 2 === 0) {
            doc.setFillColor(255, 255, 255);
         } else {
            doc.setFillColor(250, 250, 250);
         }
         doc.rect(margin, currentY, pageWidth, 4.5, 'F'); // Reduced height

         // Row data - SMALLER FONT
         doc.setFontSize(6.5); // Reduced from 7
         doc.setFont('helvetica', 'normal');
         doc.setTextColor(0, 0, 0);

         // Date
         doc.text(formatDate(serial.transactionAt || serial.date), margin + 2, currentY + 3);

         // Doc
         doc.text(serial.docno || serial.doc || '', margin + 26, currentY + 3);

         // Daybook - truncate less aggressively
         let daybook = serial.daybook || '';
         if (daybook.length > 25) daybook = daybook.substring(0, 23) + '..';
         doc.text(daybook, margin + 46, currentY + 3);

         // Account - FIXED: Show more characters without truncation
         let account = serial.account || '';
         if (account.length > 30) {
            // Try to show as much as possible
            account = account.substring(0, 28) + '..';
         }
         doc.text(account, margin + 83, currentY + 3);

         // Serial No
         let serialNo = serial.serialNo || '';
         if (serialNo.length > 20) serialNo = serialNo.substring(0, 18) + '..';
         doc.text(serialNo, margin + 125, currentY + 3);

         // NEW: No of Days - RIGHT ALIGNED
         const noOfDays = formatNoOfDays(serial.noOfDays);
         const noOfDaysWidth = doc.getTextWidth(noOfDays);
         const noOfDaysX = Math.max(margin + 159 + 15 - noOfDaysWidth - 1, margin + 159);
         doc.text(noOfDays, noOfDaysX, currentY + 3);

         // Item Rate - RIGHT ALIGNED
         const itemRate = formatCurrency(serial.itemRate);
         const itemRateWidth = doc.getTextWidth(itemRate);
         const itemRateX = Math.max(margin + 176 + 22 - itemRateWidth - 1, margin + 176);
         doc.text(itemRate, itemRateX, currentY + 3);

         // Pcs - RIGHT ALIGNED
         const pcs = formatNumber(serial.pcs);
         const pcsWidth = doc.getTextWidth(pcs);
         const pcsX = Math.max(margin + 200 + 12 - pcsWidth - 1, margin + 200);
         doc.text(pcs, pcsX, currentY + 3);

         // exprate - RIGHT ALIGNED
         const exprate = formatCurrency(serial.exprate);
         const exprateWidth = doc.getTextWidth(exprate);
         const exprateX = Math.max(margin + 214 + 22 - exprateWidth - 1, margin + 214);
         doc.text(exprate, exprateX, currentY + 3);

         // Amount - RIGHT ALIGNED - TIGHTER SPACING
         const amount = formatCurrency(serial.TotalRate || serial.amount || 0);
         const amountWidth = doc.getTextWidth(amount);
         const amountX = Math.max(margin + 238 + 25 - amountWidth - 1, margin + 238);
         doc.text(amount, amountX, currentY + 3);

         // Bottom border - LIGHTER AND THINNER
         doc.setDrawColor(240, 240, 240);
         doc.line(margin, currentY + 4.5, margin + pageWidth, currentY + 4.5);

         currentY += 4.5; // Reduced from 5
      };

      // MAIN EXECUTION
      try {
         drawHeader();

         // Process each company
         salesReport.forEach((companyData, companyIndex) => {
            if (!companyData || !companyData.data) return;

            // Draw company header (only once)
            drawCompanyHeader(companyData);

            // Process each item
            companyData.data?.forEach((item, itemIndex) => {
               if (!item.data || !Array.isArray(item.data) || item.data.length === 0) return;

               // Check space for item section
               if (currentY + 15 > pageHeight - 15) {
                  addNewPage();
               }

               // Draw item header with item data
               drawItemHeader(item.itemName || 'Unknown Item', item);

               // Draw table headers
               drawTableHeaders();

               // Draw serial rows
               item.data.forEach((serial, serialIndex) => {
                  drawSerialRow(serial, serialIndex);
               });

               // REDUCED space between items
               if (itemIndex < companyData.data.length - 1) {
                  currentY += 2; // Reduced from 4
               }
            });

            // Reset for next company
            currentCompanyData = null;

            // REDUCED space between companies
            if (companyIndex < salesReport.length - 1) {
               currentY += 4; // Reduced from 6
            }
         });

         // ADD PAGE NUMBERS
         const totalPages = doc.internal.getNumberOfPages();
         for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);

            // Footer
            doc.setFontSize(6);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(100, 100, 100);

            // Page number
            doc.text(`Page ${i} of ${totalPages}`, margin + pageWidth - 20, pageHeight - 5);

            // Generated date - only on first page
            if (i === 1) {
               doc.text(`Generated: ${formatDate(new Date())}`, margin, pageHeight - 5);
            }
         }

         // SAVE PDF
         const fileName = `Stock_Report_${formatDate(dateRange.fromDate)}_to_${formatDate(dateRange.toDate)}.pdf`;
         doc.save(fileName);

         console.log('PDF exported successfully');
      } catch (error) {
         console.error('Error exporting PDF:', error);
         alert('Failed to generate PDF. Please try again.');
      }
   };

   const { userGlobalSettingsData } = useGlobal();

   const deletePurchaseReturn = () => {
      deleteRecord(
         viewDetail?.id,
         deletePurchaseInvoice,
         dispatch,
         user?.loginhistory?.companyId,
         userGlobalSettingsData,
      );
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   const { getItemSerialWiseColumns, getItemWiseColumns, getSerialWiseColumns } = useStockReportColumns(() => ({
      dynamicOptionValues,
   }));
   // Memoized render functions
   const renderCompanyRow = useCallback(
      (companyData) => {
         const calculateCompanyTotal = () => {
            // Check if it's a dynamic custom format first
            const selectedValue = typeof itemWiseSelected === 'object' ? itemWiseSelected.value : itemWiseSelected;
            const isDynamicFormat = dynamicValues.includes(selectedValue);
            let defName = '';

            if (isDynamicFormat) {
               const dynamicFormat = dynamicOptions.find((option) => option.value === selectedValue);
               defName = dynamicFormat?.formatData?.defName;
            }

            // For Item + Serial-Wise and Serial-Wise views (including dynamic formats)
            if (
               itemWiseSelected?.value === 0 ||
               itemWiseSelected?.value === 2 ||
               itemWiseSelected?.value === 'Item + Serial-Wise' ||
               itemWiseSelected?.value === 'Serial-Wise' ||
               (isDynamicFormat && (defName === 'Item + Serial-Wise' || defName === 'Serial-Wise'))
            ) {
               return companyData.data?.reduce(
                  (acc, item) => {
                     const itemTotal = item.data?.reduce(
                        (subAcc, serial) => {
                           const pcs = parseFloat(serial.pcs) || 0;
                           const rate = parseFloat(serial.itemRate) || 0;
                           return {
                              pcs: subAcc.pcs + pcs,
                              amount: subAcc.amount + pcs * rate,
                           };
                        },
                        { pcs: 0, amount: 0 },
                     );
                     return {
                        pcs: acc.pcs + (itemTotal?.pcs || 0),
                        amount: acc.amount + (itemTotal?.amount || 0),
                     };
                  },
                  { pcs: 0, amount: 0 },
               );
            }
            // For Item-wise view (including dynamic formats)
            else if (
               itemWiseSelected?.value === 1 ||
               itemWiseSelected?.value === 'Item-wise' ||
               (isDynamicFormat && defName === 'Item-wise')
            ) {
               return {
                  purchasePcs: companyData.data?.reduce(
                     (sum, item) => sum + parseInt(item.PurchasePcs1 || item.purchasePcs || 0),
                     0,
                  ),
                  salePcs: companyData.data?.reduce(
                     (sum, item) => sum + parseInt(item.SalePcs1 || item.salePcs || 0),
                     0,
                  ),
                  balance: companyData.data?.reduce((sum, item) => sum + parseFloat(item.Bal1 || item.balance || 0), 0),
               };
            }
            return { pcs: 0, amount: 0 };
         };

         const companyTotal = calculateCompanyTotal();

         // Check if it's a dynamic custom format (moved after calculation)
         const selectedValue = typeof itemWiseSelected === 'object' ? itemWiseSelected.value : itemWiseSelected;
         const isDynamicFormat = dynamicValues.includes(selectedValue);
         let defName = '';

         if (isDynamicFormat) {
            const dynamicFormat = dynamicOptions.find((option) => option.value === selectedValue);
            defName = dynamicFormat?.formatData?.defName;
         }

         return (
            <Tr
               className={`${isDark
                  ? 'bg-gradient-to-r from-indigo-900 via-purple-900 to-indigo-900 border-l-4 border-indigo-400'
                  : 'bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-50 border-l-4 border-indigo-500'
                  } cursor-pointer transition-all duration-300 hover:shadow-lg`}
               onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
               <Td p={2}>
                  <Flex justify="space-between" align="center">
                     <Text
                        fontWeight="bold"
                        fontSize="lg"
                        className={`${isDark ? 'text-indigo-200' : 'text-indigo-900'} tracking-wide`}>
                        {companyData.companyName}
                     </Text>
                  </Flex>
               </Td>

               {/* For Item + Serial-Wise and Serial-Wise views */}
               {(itemWiseSelected?.value === 0 ||
                  itemWiseSelected?.value === 'Item + Serial-Wise' ||
                  (isDynamicFormat && defName === 'Item + Serial-Wise')) && (
                     <>
                        <Td colSpan={7} py={2} fontSize="15px" fontWeight="bold" isNumeric>
                           <Flex justifyContent="end" className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              Pcs: {companyTotal?.pcs?.toLocaleString('en-IN') || '0'}
                           </Flex>
                        </Td>
                        <Td p={2} textAlign="right">
                           <Flex
                              justifyContent="end"
                              align="center"
                              gap={3}
                              className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              <Text fontWeight="bold">Exprate:</Text>
                              <Text fontWeight="bold">₹{companyTotal?.exprate?.toLocaleString('en-IN') || '0'}</Text>
                           </Flex>
                        </Td>
                        <Td p={2} textAlign="right">
                           <Flex
                              justifyContent="end"
                              align="center"
                              gap={3}
                              className={isDark ? 'text-indigo-200' : 'text-indigo-800'}>
                              <Text fontWeight="bold">Amount:</Text>
                              <Text fontWeight="bold">₹{companyTotal?.amount?.toLocaleString('en-IN') || '0'}</Text>
                              {expandedItems[`company-${companyData.companyId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                           </Flex>
                        </Td>
                     </>
                  )}

               {/* For Serial-Wise view */}
               {(itemWiseSelected?.value === 2 ||
                  itemWiseSelected?.value === 'Serial-Wise' ||
                  (isDynamicFormat && defName === 'Serial-Wise')) && (
                     <>
                        <Td colSpan={8} py={2} fontSize="15px" fontWeight="bold" isNumeric>
                           <Flex justifyContent="end" className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              Pcs: {companyTotal?.pcs?.toLocaleString('en-IN') || '0'}
                           </Flex>
                        </Td>
                        <Td p={2} textAlign="right">
                           <Flex
                              justifyContent="end"
                              align="center"
                              gap={3}
                              className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              <Text fontWeight="bold">Exprate:</Text>
                              <Text fontWeight="bold">₹{companyTotal?.exprate?.toLocaleString('en-IN') || '0'}</Text>
                           </Flex>
                        </Td>
                        <Td p={2} textAlign="right">
                           <Flex
                              justifyContent="end"
                              align="center"
                              gap={3}
                              className={isDark ? 'text-indigo-200' : 'text-indigo-800'}>
                              <Text fontWeight="bold">Amount:</Text>
                              <Text fontWeight="bold">₹{companyTotal?.amount?.toLocaleString('en-IN') || '0'}</Text>
                              {expandedItems[`company-${companyData.companyId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                           </Flex>
                        </Td>
                     </>
                  )}

               {/* For Item-wise view */}
               {(itemWiseSelected?.value === 1 ||
                  itemWiseSelected?.value === 'Item-wise' ||
                  (isDynamicFormat && defName === 'Item-wise')) && (
                     <>
                        <Td py={2} fontSize="15px" fontWeight="bold" isNumeric colSpan={2}>
                           <Flex justifyContent="end" className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              Total Exprate : {companyTotal?.exprate?.toLocaleString('en-IN') || '0'}
                           </Flex>
                        </Td>
                        <Td py={2} fontSize="15px" fontWeight="bold" isNumeric>
                           <Flex justifyContent="end" className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              Total Purchase Pcs: {companyTotal?.purchasePcs?.toLocaleString('en-IN') || '0'}
                           </Flex>
                        </Td>
                        <Td py={2} fontSize="15px" fontWeight="bold" isNumeric>
                           <Flex justifyContent="end" className={isDark ? 'text-indigo-300' : 'text-indigo-700'}>
                              Total Sale Pcs: {companyTotal?.salePcs?.toLocaleString('en-IN') || '0'}
                           </Flex>
                        </Td>
                        <Td p={2} textAlign="right">
                           <Flex
                              justifyContent="end"
                              align="center"
                              gap={3}
                              className={isDark ? 'text-indigo-200' : 'text-indigo-800'}>
                              <Text fontWeight="bold">Total Balance:</Text>
                              <Text fontWeight="bold">₹{companyTotal?.balance?.toLocaleString('en-IN') || '0'}</Text>
                              {expandedItems[`company-${companyData.companyId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                           </Flex>
                        </Td>
                     </>
                  )}
            </Tr>
         );
      },
      [expandedItems, itemWiseSelected, isDark, toggleExpand, dynamicValues, dynamicOptions],
   );

   const renderItemSerialWiseData = useCallback(
      (companyData) => {
         const columns = getItemSerialWiseColumns();

         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);
            if (data.companyId === companyId && data?.serialNo !== "NON-SERIALIZED") {
               await dispatch(getPurchaseInvoice(data.purchaseHeaderId));
               setIsOpenPurchaseReturnSingleView(true);
            }
         };

         const getColumnStyles = (columnId) => {
            const columnInfo = columns.find((col) => col.id === columnId);
            if (!columnInfo) return {};

            return {
               color: columnInfo.color || textColor,
               fontWeight: columnInfo.isBold ? 'bold' : 'normal',
               fontStyle: columnInfo.isItalic ? 'italic' : 'normal',
               textAlign: columnInfo.isNumeric ? 'right' : 'left',
            };
         };

         const getColumnOrder = () => {
            return [...columns].sort((a, b) => {
               const orderA = a.orderNo || 0;
               const orderB = b.orderNo || 0;
               return orderA - orderB;
            });
         };

         const orderedColumns = getColumnOrder();
         const detailedViewColumns = orderedColumns.filter((column) => column.accessor !== 'itemName');

         const renderCellValue = (column, rowData, itemData = null) => {
            let value;

            if (typeof column.accessor === 'function') {
               value = column.accessor(rowData);
            } else if (column.accessor === 'itemName' && itemData) {
               value = itemData.itemName;
            } else {
               value = rowData[column.accessor];
            }

            if (column.render) {
               return column.render(value, rowData);
            }

            return (
               <Text
                  fontWeight={column.isBold ? 'bold' : 'normal'}
                  fontStyle={column.isItalic ? 'italic' : 'normal'}
                  color={column.color || textColor}
                  textAlign={column.isNumeric ? 'right' : 'left'}>
                  {value}
               </Text>
            );
         };

         return companyData.data.map((itemData, itemIndex) => (
            <React.Fragment key={`item-${itemData.itemId || itemIndex}`}>
               <Tr
                  className={`${isDark
                     ? 'bg-gradient-to-r from-slate-800 to-slate-900 border-l-4 border-cyan-400'
                     : 'bg-gradient-to-r from-cyan-50 to-blue-50 border-l-4 border-cyan-500'
                     } cursor-pointer transition-all duration-300 hover:shadow-md`}
                  onClick={() => toggleExpand(`item-${itemData.itemId}-${companyData.companyId}`)}>
                  <Td colSpan={7} p={2}>
                     <Flex justifyContent="space-between" alignItems="center" pl={2}>
                        <Text fontWeight="bold" className={`${isDark ? 'text-cyan-200' : 'text-cyan-900'} text-base`}>
                           {itemData.itemName}
                        </Text>
                     </Flex>
                  </Td>
                  <Td
                     py={2}
                     fontSize="15px"
                     fontWeight="bold"
                     isNumeric
                     className={isDark ? 'text-cyan-300' : 'text-cyan-700'}
                     style={getColumnStyles('pcs')}>
                     Pcs : {itemData.data.reduce((sum, serial) => sum + parseInt(serial.pcs || 0), 0)}
                  </Td>
                  <Td
                     py={2}
                     fontSize="15px"
                     fontWeight="bold"
                     isNumeric
                     className={isDark ? 'text-cyan-300' : 'text-cyan-700'}
                     style={getColumnStyles('amount')}>
                     <Flex alignItems={'center'} justifyContent="end">
                        <Flex alignItems={'center'} gap={4}>
                           Exprate : ₹
                           {itemData.data
                              .reduce(
                                 (sum, serial) => sum + parseFloat(serial.exprate || 0) * parseFloat(serial.pcs || 0),
                                 0,
                              )
                              .toLocaleString()}
                        </Flex>
                     </Flex>
                  </Td>
                  <Td
                     py={2}
                     fontSize="15px"
                     fontWeight="bold"
                     isNumeric
                     className={isDark ? 'text-cyan-200' : 'text-cyan-800'}
                     style={getColumnStyles('amount')}>
                     <Flex alignItems={'center'} justifyContent="end">
                        <Flex alignItems={'center'} gap={4}>
                           Amount : ₹
                           {itemData.data
                              .reduce(
                                 (sum, serial) => sum + parseFloat(serial.TotalRate || 0) * parseFloat(serial.pcs || 0),
                                 0,
                              )
                              .toLocaleString()}
                        </Flex>
                        {expandedItems[`item-${itemData.itemId}-${companyData.companyId}`] ? (
                           <ChevronUpIcon />
                        ) : (
                           <ChevronDownIcon />
                        )}
                     </Flex>
                  </Td>
               </Tr>

               {expandedItems[`item-${itemData.itemId}-${companyData.companyId}`] && (
                  <>
                     <Tr
                        className={`${isDark
                           ? 'bg-slate-900 border-b-2 border-slate-700'
                           : 'bg-slate-100 border-b-2 border-slate-300'
                           }`}>
                        {detailedViewColumns.map((column) => (
                           <Td
                              key={column.id}
                              py={2}
                              fontSize="12px"
                              fontWeight="bold"
                              color={column.color || textColor}
                              isNumeric={column.isNumeric}
                              flex={column.flex}
                              className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                              {column.header}
                           </Td>
                        ))}
                     </Tr>

                     {itemData.data?.map((serialData, serialIndex) => {
                        const isOddRow = serialIndex % 2 !== 0;
                        const hasIssueLineDetail =
                           serialData.issueLineDetailId !== null && serialData.issueLineDetailId !== 0;
                        return (
                           <Tr
                              key={`serial-${serialData.id || serialIndex}`}
                              className={`cursor-pointer transition-all duration-200 ${hasIssueLineDetail
                                 ? isDark
                                    ? 'bg-red-900 bg-opacity-30 hover:bg-red-800 hover:bg-opacity-40'
                                    : 'bg-red-50 hover:bg-red-100'
                                 : isOddRow
                                    ? isDark
                                       ? 'bg-slate-800 bg-opacity-50 hover:bg-slate-700'
                                       : 'bg-slate-50 hover:bg-slate-100'
                                    : isDark
                                       ? 'bg-transparent hover:bg-slate-800 hover:bg-opacity-30'
                                       : 'bg-white hover:bg-slate-50'
                                 }`}
                              onClick={() => handledata(serialData)}>
                              {detailedViewColumns.map((column) => (
                                 <Td
                                    key={column.id}
                                    py={2}
                                    fontSize="12px"
                                    fontWeight={600}
                                    color={column.color || textColor}
                                    isNumeric={column.isNumeric}
                                    flex={column.flex}>
                                    {renderCellValue(column, serialData, itemData)}
                                 </Td>
                              ))}
                           </Tr>
                        );
                     })}
                  </>
               )}
            </React.Fragment>
         ));
      },
      [expandedItems, formatDateToDDMMYYYY, textColor, toggleExpand, getItemSerialWiseColumns, isDark],
   );

   const renderItemWiseData = useCallback(
      (companyData) => {
         const columns = getItemWiseColumns();

         const getColumnOrder = () => {
            return [...columns].sort((a, b) => {
               const orderA = a.orderNo || 0;
               const orderB = b.orderNo || 0;
               return orderA - orderB;
            });
         };

         const orderedColumns = getColumnOrder();
         const flatData = companyData.data || [];

         const renderCellValue = (column, rowData, itemData = null) => {
            let value;

            if (typeof column.accessor === 'function') {
               value = column.accessor(rowData);
            } else if (column.accessor === 'itemName' && itemData) {
               value = itemData.itemName;
            } else {
               value = rowData[column.accessor];
            }

            if (column.render) {
               return column.render(value, rowData);
            }

            return (
               <Text
                  fontWeight={column.isBold ? 'bold' : 'normal'}
                  fontStyle={column.isItalic ? 'italic' : 'normal'}
                  color={column.color || textColor}
                  textAlign={column.isNumeric ? 'right' : 'left'}>
                  {value}
               </Text>
            );
         };

         return (
            <>
               <Tr
                  className={`${isDark ? 'bg-slate-900 border-b-2 border-slate-700' : 'bg-slate-100 border-b-2 border-slate-300'
                     }`}>
                  {orderedColumns.map((column) => (
                     <Td
                        key={column.id}
                        p={2}
                        fontSize="12px"
                        fontWeight="bold"
                        color={column.color || textColor}
                        isNumeric={column.isNumeric}
                        flex={column.flex}
                        className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                        {column.header}
                     </Td>
                  ))}
               </Tr>

               {flatData.map((itemData, itemIndex) => (
                  <Tr
                     key={`flat-serial-${itemData.id || itemIndex}`}
                     className={`transition-all duration-200 ${itemIndex % 2 === 0
                        ? isDark
                           ? 'bg-slate-800 bg-opacity-30 hover:bg-slate-700 hover:bg-opacity-50'
                           : 'bg-white hover:bg-slate-50'
                        : isDark
                           ? 'bg-slate-800 bg-opacity-50 hover:bg-slate-700'
                           : 'bg-slate-50 hover:bg-slate-100'
                        }`}>
                     {orderedColumns.map((column) => (
                        <Td
                           key={column.id}
                           p={2}
                           fontSize="12px"
                           fontWeight={column.isBold ? 'bold' : 'normal'}
                           color={column.color || textColor}
                           isNumeric={column.isNumeric}
                           flex={column.flex}>
                           {renderCellValue(column, itemData)}
                        </Td>
                     ))}
                  </Tr>
               ))}
            </>
         );
      },
      [textColor, getItemWiseColumns, isDark],
   );

   const renderSerialWiseData = useCallback(
      (companyData, sortOrder = 'asc') => {
         const columns = getSerialWiseColumns();

         const getColumnOrder = () => {
            return [...columns].sort((a, b) => {
               const orderA = a.orderNo || 0;
               const orderB = b.orderNo || 0;
               return orderA - orderB;
            });
         };

         const orderedColumns = getColumnOrder();

         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);
            if (data.companyId === companyId) {
               await dispatch(getPurchaseInvoice(data.purchaseHeaderId));
               setIsOpenPurchaseReturnSingleView(true);
            }
         };

         const renderCellValue = (column, rowData, itemData = null) => {
            let value;

            if (typeof column.accessor === 'function') {
               value = column.accessor(rowData);
            } else if (column.accessor === 'itemName' && itemData) {
               value = itemData.itemName;
            } else {
               value = rowData[column.accessor];
            }

            if (column.render) {
               return column.render(value, rowData);
            }

            return (
               <Text
                  fontWeight={column.isBold ? 'bold' : 'normal'}
                  fontStyle={column.isItalic ? 'italic' : 'normal'}
                  color={column.color || textColor}
                  textAlign={column.isNumeric ? 'right' : 'left'}>
                  {value}
               </Text>
            );
         };

         // FLAT DATA बनाएँ और sort करें
         const getFlatSortedData = () => {
            // सभी serial data को flat array में convert करें
            const flatData = companyData.data.flatMap((itemData) =>
               itemData.data.map((serialData) => ({
                  ...serialData,
                  itemName: itemData.itemName,
                  itemData: itemData,
               })),
            );

            // noOfDays के according sort करें
            const sortedData = [...flatData].sort((a, b) => {
               const aValue = parseFloat(a.noOfDays || 0);
               const bValue = parseFloat(b.noOfDays || 0);

               if (sortOrder === 'asc') {
                  return aValue - bValue;
               } else {
                  return bValue - aValue;
               }
            });

            return sortedData;
         };

         const sortedData = getFlatSortedData();

         console.log('Sorted Data (noOfDays):', {
            sortOrder,
            dataLength: sortedData.length,
            firstFew: sortedData.slice(0, 3).map((d) => ({
               noOfDays: d.noOfDays,
               serialNo: d.serialNo,
            })),
         });

         return (
            <>
               <Tr
                  className={`${isDark ? 'bg-slate-900 border-b-2 border-slate-700' : 'bg-slate-100 border-b-2 border-slate-300'
                     }`}>
                  {orderedColumns.map((column) => (
                     <Td
                        key={column.id}
                        py={2}
                        fontSize="12px"
                        fontWeight="bold"
                        color={column.color || textColor}
                        isNumeric={column.isNumeric}
                        flex={column.flex}
                        className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                        {column.header}
                     </Td>
                  ))}
               </Tr>

               {sortedData.map((serialData, index) => (
                  <Tr
                     key={`sorted-serial-${serialData.id || index}`}
                     className={`cursor-pointer transition-all duration-200 ${index % 2 === 0
                        ? isDark
                           ? 'bg-transparent hover:bg-slate-800 hover:bg-opacity-30'
                           : 'bg-white hover:bg-slate-50'
                        : isDark
                           ? 'bg-slate-800 bg-opacity-50 hover:bg-slate-700'
                           : 'bg-slate-50 hover:bg-slate-100'
                        }`}
                     onClick={() => handledata(serialData)}>
                     {orderedColumns.map((column) => (
                        <Td
                           key={column.id}
                           py={2}
                           fontSize="12px"
                           color={column.color || textColor}
                           isNumeric={column.isNumeric}
                           flex={column.flex}>
                           {renderCellValue(column, serialData, serialData.itemData)}
                        </Td>
                     ))}
                  </Tr>
               ))}
            </>
         );
      },
      [formatDateToDDMMYYYY, textColor, getSerialWiseColumns, isDark, dispatch],
   );

   const renderStockReportContent = useCallback(
      (companyData) => {
         if (!itemWiseSelected) return null;

         const selectedValue = typeof itemWiseSelected === 'object' ? itemWiseSelected.value : itemWiseSelected;
         const isDynamicFormat = dynamicValues.includes(selectedValue);

         if (isDynamicFormat) {
            const dynamicFormat = dynamicOptions.find((option) => option.value === selectedValue);
            const defName = dynamicFormat?.formatData?.defName;

            switch (defName) {
               case 'Item + Serial-Wise':
                  return renderItemSerialWiseData(companyData);
               case 'Item-wise':
                  return renderItemWiseData(companyData);
               case 'Serial-Wise':
                  return renderSerialWiseData(companyData, sortOrder); // sortOrder pass करें
               default:
                  return renderItemSerialWiseData(companyData);
            }
         }

         switch (selectedValue) {
            case 0:
            case 'Item + Serial-Wise':
               return renderItemSerialWiseData(companyData);
            case 1:
            case 'Item-wise':
               return renderItemWiseData(companyData);
            case 2:
            case 'Serial-Wise':
               return renderSerialWiseData(companyData, sortOrder); // sortOrder pass करें
            default:
               return renderItemSerialWiseData(companyData);
         }
      },
      [
         itemWiseSelected,
         dynamicValues,
         dynamicOptions,
         renderItemSerialWiseData,
         renderItemWiseData,
         renderSerialWiseData,
         sortOrder, // sortOrder को dependency में add करें
      ],
   );

   // Memoized report data
   const memoizedReportData = useMemo(() => {
      if (!salesReport || salesReport.length === 0) return null;

      return salesReport.map((companyData, companyIndex) => (
         <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
            {renderCompanyRow(companyData)}
            {expandedItems[`company-${companyData.companyId}`] &&
               companyData.data &&
               renderStockReportContent(companyData)}
         </React.Fragment>
      ));
   }, [salesReport, expandedItems, renderCompanyRow, renderStockReportContent]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData =
         typeof itemWiseSelected === 'object'
            ? itemWiseSelected.formatData
            : reportformat.find((f) => f.title === itemWiseSelected);

      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);

         setShowHideData({
            title: formatData.title,
            defName: formatData.defName,
            viewJson: formatData.viewJson || [],
         });
      } else {
         setIsEditShowHide(false);
         setEditData({});
         setShowHideData({
            title: itemWiseSelected,
            defName: itemWiseSelected,
            viewJson: [],
         });
      }
   };

   return (
      <>
         {/* Header */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Stock
               </Text>
            </Flex>
            <Flex gap={2}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {staticOption ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         {/* Filters */}
         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <Box
                     my={2}
                     width="250px"
                     fontSize={'13px'}
                     mt={5}
                     fontWeight={500}
                     display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <Box my={2} width="130px" fontSize="13px" fontWeight={500}>
                     <label>Report-Type</label>
                     <Select
                        placeholder="Select Report-Type"
                        name="Report-Type"
                        options={stockTypeOptions}
                        value={itemWiseSelected}
                        formatOptionLabel={formatOptionLabel}
                        onChange={handleItemWiseChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} width="100px" fontSize="13px" fontWeight={500}>
                     <label>Stock-Status</label>
                     <Select
                        placeholder="Select Stock-Status"
                        name="Stock-Status"
                        options={stockStatusDrop.map((comp) => ({ value: comp.id, label: comp.name }))}
                        value={stockWiseSelected}
                        onChange={handleStockWiseChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} width="130px" fontSize="13px" fontWeight={500}>
                     <label>Serial Type</label>
                     <Select
                        placeholder="Select-Status"
                        name="Stock-Status"
                        options={serialType.map((comp) => ({ value: comp.id, label: comp.name }))}
                        value={serialFilter}
                        onChange={(option) => setSerialFilter(option)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} width="130px" fontSize="13px" fontWeight={500}>
                     <label>Store Stock Type</label>
                     <Select
                        placeholder="Select-Status"
                        name="Stock-Status"
                        options={stocktype.map((comp) => ({ value: comp.id, label: comp.name }))}
                        value={stockTypeSelected}
                        onChange={(option) => setStockTypeSelected(option)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Flex className="flex flex-wrap gap-2">
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}
                        overflow="hidden">
                        <MotionSearchIcon
                           color={iconColor}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '0',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <InputGroup width="200px">
                              <Input
                                 placeholder="Search..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 color={iconColor}
                                 variant="unstyled"
                                 _placeholder={{ color: 'gray.400' }}
                              />
                           </InputGroup>
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={() => fetchData()} _hover={{ bg: 'blue.50' }} mr={2}>
                     <MdOutlineRefresh size={20} mr={2} />
                  </Button>
                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>
                  <Popover>
                     <PopoverTrigger>
                        <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToExcel}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Excel
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToPDF}
                              justifyContent="space-between">
                              <img src={xls} alt="Download Pdf" width="30px" mr></img>
                              Download Pdf
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Box ml="">
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               {/* Mobile Drawer */}
               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>

                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Account</label>
                           <Select
                              placeholder="Select Report-Type"
                              name="Report-Type"
                              options={stockDrop.map((comp) => ({ value: comp.id, label: comp.name }))}
                              value={itemWiseSelected}
                              onChange={handleItemWiseChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                           />
                        </Box>

                        <Box my={2} width="170px" fontSize="13px" fontWeight={500}>
                           <label>Stock Type</label>
                           <Select
                              placeholder="Select Stock-Status"
                              name="Stock-Status"
                              options={stocktype.map((comp) => ({ value: comp.id, label: comp.name }))}
                              value={stockTypeSelected}
                              onChange={(option) => setStockTypeSelected(option)}
                              className="basic-multi-select"
                              classNamePrefix="select"
                           />
                        </Box>

                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         {/* Table */}
         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>
                        {isLoading ? (
                           <Tr>
                              <Td colSpan={8} textAlign="center" py="100px">
                                 <Loader />
                              </Td>
                           </Tr>
                        ) : (
                           memoizedReportData || (
                              <Tr>
                                 <Td colSpan={8} textAlign="center" py={10}>
                                    <Flex direction="column" align="center" justify="center">
                                       <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                                       <Text mt={4}>No stock data found</Text>
                                    </Flex>
                                 </Td>
                              </Tr>
                           )
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <StockFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            stockStatus={stockWiseSelected?.value}
            entityType="stock"
            reportType={selectedReportType}
            onSortOrderChange={handleSortChange}
            sortOrder={sortOrder}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={stockTypeOptions.dynamicOptions}
            FixdefName1={'Item + Serial-Wise'}
            FixdefName2={'Item-wise'}
            FixdefName3={'Serial-Wise'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={'Purchase Invoice'}
            entityType={'purchaseinvoice'}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            // paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => console.log('')}
         />
      </>
   );
};

export default Stock;
